import { Fragment } from "react";
import PropTypes from "prop-types";

export function Hidden({ children, condition }) {
  if (condition) return null;
  return <Fragment>{children}</Fragment>;
}

Hidden.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.bool.isRequired,
};
